import React from "react";
import "./ColorShadesGrid.css";

/**
 * Reusable shade swatch grid (same visuals as BackgroundControlColorMenu shades).
 */
const ColorShadesGrid = ({
  shades = [],
  selectedShade = null,
  onShadeSelect = () => {},
  heading = "Shades",
  hint = null,
  loading = false,
}) => {
  if (loading) {
    return (
      <div className="color-shades-grid shades-section">
        <p className="shades-heading">{heading}</p>
        {hint ? <p className="shades-hint">{hint}</p> : null}
        <div className="shades-preloader-container">
          <div className="shades-preloader" />
          <p className="shades-loading-text">Generating shades...</p>
        </div>
      </div>
    );
  }

  if (!shades.length) return null;

  return (
    <div className="color-shades-grid shades-section">
      <p className="shades-heading">{heading}</p>
      {hint ? <p className="shades-hint">{hint}</p> : null}
      <div className="shades-grid">
        {shades.map((shade, index) => (
          <div
            key={`${shade}-${index}`}
            className={`shade-swatch ${
              selectedShade === shade ? "shade-selected" : ""
            }`}
            style={{ backgroundColor: shade }}
            onClick={() => onShadeSelect(shade)}
            role="button"
            tabIndex={0}
            title={shade}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onShadeSelect(shade);
              }
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default ColorShadesGrid;
